import { customToast } from "../Toast";
import GPTModal from "../../container/GPTModal";
import Send from "../../core/communication";

export const ESMModalActions = ({
  handleCloseActionsModal,
  showModalActions,
  scaleIndicatorId,
  esmId,
  actionType = 'action',
  actionList,
  userId,
  projectId
}) => {

  const onSaveAction = async (data) => {
    const isEmptyValue = data.some(({ area, level }) => area === "" || level === "")

    if (isEmptyValue) {
      customToast("Selecione a area, o nível e confirme", "info");
      return;
    }

    data = data
      .filter((item) => item?.title)
      .map((item) => ({
        ...item,
        scaleIndicator: scaleIndicatorId,
        scale: esmId,
      }))

    const response = await Send.post("/scale-action", data)

    if (response && response?.status === "success") {
      customToast("Ações adicionadas", "success")
      handleCloseActionsModal();
      return
    } else {
      customToast("Erro ao adicionar ações", "error")
      handleCloseActionsModal();
    }
  }

  const onSaveActionProducer = async (data, userId) => {

    const isEmptyValue = data.some(({ area, level }) => area === "" || level === "")

    if (isEmptyValue) {
      customToast("Selecione a area, o nível e confirme", "info");
      return;
    }

    try {
      const response = await Send.post(`/scale-action-producer`, data.map(item => ({
        ...item,
        userId,
        scaleIndicatorId,
        scaleId: esmId
      })));

      if(response && response.status === 'error') {
        throw new Error(response);
      }
      
      customToast('Ação salva com sucesso.', 'success');
      handleCloseActionsModal();
    } catch(error) {
      console.log("ERROR", error)
      customToast('Erro ao salvar ação', 'error')
    }
  }

  const onSaveActionProject = async (data) => {
    const isEmptyValue = data.some(({ area, level }) => area === "" || level === "")

    if (isEmptyValue) {
      customToast("Selecione a area, o nível e confirme", "info");
      return;
    }

    try {
      const response = await Send.post(`/scale-action-project`, data.map(item => ({
        ...item,
        projectId,
        scaleIndicatorId: scaleIndicatorId?.id || scaleIndicatorId,
        scaleId: esmId
      })));

      if(response && response.status === 'error') {
        throw new Error(response);
      }
      
      customToast('Ação salva com sucesso.', 'success');
      handleCloseActionsModal();
    } catch(error) {
      console.log("ERROR", error)
      customToast('Erro ao salvar ação', 'error')
    }
  }

  const handleSaveActions = (data) => {
    if(actionType === 'action') {
      onSaveAction(data);
      return;
    } else if(actionType === 'actionProducer') {
      onSaveActionProducer(data, userId);
      return;
    } else if(actionType === 'actionCommunity') {
      onSaveActionProject(data);
      return;
    }
  }

  return <GPTModal
    title="Ações"
    onSaveActions={handleSaveActions}
    actions={[]}
    actionList={actionList}
    hiddenAddingButton
    showModalActions={showModalActions}
    setShowModalActions={handleCloseActionsModal}
    handleCloseActionsModal={handleCloseActionsModal}
  />
}